import { GetCouponRes } from "../../services";

export const couponData_3: GetCouponRes[] = [
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
];
export const couponData_4: GetCouponRes[] = [
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
  {
    couponId: 1,
    category: "카페",
    brandId: 11,
    couponCode: "URL링크에서발급",
    couponUrl: "/img/brand/starbucks.svg",
    description: "자바칩 프라푸치노",
    popularity: 50,
    useCount: 42,
    likeCount: 30,
    dislikeCount: 12,
    brandName: "스타벅스",
    couponName: "자바칩 프라푸치노",
    startDate: "2023.08.02",
    endDate: "2023.09.02",
    brandImgUrl: "",
  },
];
